import { render, staticRenderFns } from "./EditGiveaway.vue?vue&type=template&id=1a2b9fc3&scoped=true"
import script from "./EditGiveaway.vue?vue&type=script&lang=js"
export * from "./EditGiveaway.vue?vue&type=script&lang=js"
import style0 from "./EditGiveaway.vue?vue&type=style&index=0&id=1a2b9fc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2b9fc3",
  null
  
)

export default component.exports